/**
 * Normalize patient identifiers coming from mixed dashboard/API payloads.
 * Does not change clinical scoring.
 */

const INVALID_IDS = new Set(["", "undefined", "null", "none"]);

export function resolvePatientRecordId(record) {
  if (record == null) return "";
  if (typeof record === "string" || typeof record === "number") {
    return normalizeIdValue(record);
  }
  if (typeof record !== "object") return "";
  return normalizeIdValue(
    record.id ?? record._id ?? record.patient_id ?? record.paciente_id
  );
}

function normalizeIdValue(value) {
  const id = String(value ?? "").trim();
  if (!id || INVALID_IDS.has(id.toLowerCase())) return "";
  return id;
}

export function patientProfilePath(record) {
  const id = resolvePatientRecordId(record);
  return id ? `/pacientes/${id}` : null;
}

export function patientRecordLabel(record) {
  if (!record || typeof record !== "object") return "Paciente";
  const full = String(record.nombre_completo || record.patient_name || record.nombre || "").trim();
  if (full) return full;
  const parts = [record.nombres, record.apellidos].map((part) => String(part || "").trim()).filter(Boolean);
  return parts.join(" ") || "Paciente";
}
